import { identity } from "lodash";

export * from "./component";
export * from "./types";

import RichEditor from "./component";

export default RichEditor;

export const preloadRichEditor = identity; //() => SummernoteLight.preload();
